import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperUnitsModelsComponent: {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
    containerHeader: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    containerLeftSide: {
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      alignItems: "center",
      [theme.breakpoints.down(321)]: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    containerCards: {
      display: "flex",
      flexDirection: "row",
      gap: "24px",
      flexWrap: "wrap",
    },
    containerMainTitle: {
      fontSize: "30px",
      fontWeight: 600,
      lineHeight: "38px",
      color: theme.palette.text.primary,
    },
  };
});
